import BoxContainer from './BoxContainer';
import Content from './Content';
import SideBar from './SideBar';
import Top from './Top';

export { BoxContainer, Content, SideBar, Top };
